import { render, staticRenderFns } from "./WelcomeWidget.vue?vue&type=template&id=2d13b39f&scoped=true"
import script from "./WelcomeWidget.vue?vue&type=script&lang=js"
export * from "./WelcomeWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d13b39f",
  null
  
)

export default component.exports